import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDeleteLegalClientHeadMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

interface Args {
  id: string;
  reason: string;
  versionNumber: number;
}

export const useDeleteLegalClientHead = () => {
  const [handle, { loading, error: apolloError }] =
    useDeleteLegalClientHeadMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    deleteLegalClientHead: useCallback(
      async (input: Args) => {
        const res = await handle({ variables: input });
        return res.data?.deleteLegalClientHead;
      },
      [handle]
    ),
  };
};
